import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { DriversApi } from './api'

const useCreateDriver = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_create_driver.'

  const queryClient = useQueryClient()

  const onCreateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.DRIVERS)
    queryClient.fetchQuery(QUERY_KEYS.USER)
  }

  const { mutate, isLoading: isLoadingDriver } = useMutation(DriversApi.createDriver, {
    onSuccess: () => {
      notification.success({
        message: 'Nuevo conductor creado correctamente',
      })
      onCreateSuccess()
    },
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data.error as {
        type: string
        status: number
        message: string
      }
      if (errorResponse.type === 'NO_ACTIVE_ROUTE') {
        const hint =
          errorResponse.message.length > 62
            ? `${t(`${tPreffix}no_active_route_hint`)} ${errorResponse.message.substring(
                62,
                errorResponse.message.length,
              )}`
            : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

        notification.error({
          message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
        })
      } else {
        notification.error({
          message: 'Error, no se pudo crear el chofer',
        })
      }
    },
  })

  return {
    createDriver: mutate,
    isLoadingDriver,
  }
}

export { useCreateDriver }
